// store/modules/checkoutPage.js
import PatcraftApi from "../../../scripts/patcraft-api";

// Initial state
const state = () => ({
  addresses: [],
  checkoutData: [],
  countryState: [],
  currentAddress: null,
  showAddressSuggestion: false,
  editAddressModal: true,
  validationErrorPName: null,
  isDefaultSelected: false,
  loader: false,
  isMultipleAddressCheckout: false,
  multipleItemsAddress: {
    siteItems: [],
    trayItems: []
  },
  multipleItemShippingOption: {
    siteItems: [],
    trayItems: []
  },
  checkoutList: {
    siteItems: [],
    trayItems: []
  },
  loader: false,
  validationErrorFlag: false,
  errors: {
    firstName: "",
    lastName: "",
    streetLine1: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    cellPhone: "",
    email: "",
    company: ""
  },
  mellisaValidation: {},
  currentAddressOption: {},
  showrooms: [],
  showroomLocations: [],
  gimbleData: {},
  inStock: true,
  showroomCodeName: "",
  vehicleMake: "",
  vehicleModel: "",
  vehicleColor: "",
  deliveryMethod: "",
  opportunityId: null,
  opportunityName: "",
  opportunityType: "",
  opportunityAccountId: "",
  opportunityError: "",
  opportunityDynamicProperties: {},
  showOpportunityForm: false,
  existingProjectOptions: [],
  contactData: {},
  picklistValues: [],
  opportunityData: {
    selectedUserProject: null,
    selectedType: null,
    selectedProject: null,
    accountId: null,
    contactData: null,
    dynamicProperties:null
  },
});

// Getters
const getters = {
  opportunityData: state => state.opportunityData,
  opportunityName: state => state.opportunityName,
  opportunityType: state => state.opportunityType,
  opportunityAccountId: state => state.opportunityAccountId,
  opportunityDynamicProperties: state => state.opportunityDynamicProperties,
  opportunityId: state => state.opportunityId,
  getMultipleAddressCheckout: state => state.isMultipleAddressCheckout,
  addresses: state => state.addresses,
  vehicleMake: state => state.vehicleMake,
  vehicleModel: state => state.vehicleModel,
  vehicleColor: state => state.vehicleColor,
  deliveryMethod: state => state.deliveryMethod,
  gimbleData: state => state.gimbleData,
  inStock: state => state.inStock,
  showroomCodeName: state => state.showroomCodeName,
  showrooms: state => state.showrooms,
  showroomLocations: state => state.showroomLocations,
  countryData: state => state.checkoutData.Countries,
  countryState: state => state.countryState,
  checkoutData: state => state.checkoutData,
  checkoutItemList: state => state.checkoutList,
  getMultipleItemsAddress: state => state.multipleItemsAddress,
  showAddressSuggestion: state => state.showAddressSuggestion,
  getMultipleItemShippingOption: state => state.multipleItemShippingOption.siteItems,
  getEditAddressModal: state => state.editAddressModal,
  getValidationErrorPName: state => state.validationErrorPName,
  getIsDefaultSelected: state => state.isDefaultSelected,
  getLoader: state => state.loader,
  getValidationError: state => state.errors,
  getAddressErrorValidationFlag: state => state.validationErrorFlag,
  getCurrentAddressIndex: state => state.currentAddress,
  getMellisaValidation: state => state.mellisaValidation,
  getAddressById: state => addressId => state.addresses.find(({ id }) => id === addressId),
  getCurrentAddressOption: state => {
    let addressId;
    if (state.currentAddressOption && state.currentAddressOption.isMultiple) {
      if (state.currentAddressOption.list === "SiteItems") {
        addressId = state.multipleItemsAddress.siteItems[state.currentAddressOption.index];
      } else {
        addressId = state.multipleItemsAddress.trayItems[state.currentAddressOption.index];
      }
    } else {
      addressId = state.currentAddress;
    }
    let data = { addressIndex: 0 };
    if (addressId) {
      data.addressIndex = state.addresses.findIndex(({ id }) => id === addressId);
    }
    return data;
  }
};

// Actions
const actions = {
  // Salesforce Opportunities
  updateOpportunityData({ commit }, data) {
    commit("setOpportunityData", data);
  },
  SetOpportunityId({ commit }, data) {
    commit("setOpportunityId", data);
  },
  setOpportunityName({ commit }, data) {
    commit("setOpportunityName", data);
  },
  setOpportunityType({ commit }, data) {
    commit("setOpportunityType", data);
  },
  setOpportunityAccountId({ commit }, data) {
    commit("setOpportunityAccountId", data);
  },
  setOpportunityProperties({ commit }, data) {
    commit("setOpportunityProperties", data);
  },
  setShowOpportunityForm({ commit }, data) {
    commit("setShowOpportunityForm", data);
  },
  setContactData({ commit }, data) {
    commit("setContactData", data);
  },
  setOpportunityError({ commit }, data) {
    commit("setOpportunityError", data);
  },
  setPicklistValues({ commit }, data) {
    commit("setPicklistValues", data);
  },
  setOpportunityOptions({ commit }, data) {
    commit("setOpportunityOptions", data);
  },
  async fetchAddresses({ commit, state, dispatch }, data) {
    commit("updateLoader", true);
    await PatcraftApi.getUserAddresses(data)
      .then(res => {
        if (res.data) {
          let userAccountData = JSON.parse(res.data);
          commit("setAddresses", userAccountData);
        }
      })
      .catch(error => {})
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  // Checkout and Shipping
  setProjectName({ commit }, data) {
    commit("setProjectName", data);
  },
  setCurrentAddress({ commit }, data) {
    commit("setCurrentAddress", data);
  },
  checkoutSubmit({ commit, dispatch, state }, data) {
    commit("updateLoader", true);

    // Validate Project Name
    if (state.checkoutData.ProjectName === "" || state.checkoutData.ProjectName === null) {
      state.validationErrorPName = true;
      dispatch(
        "notifications/add",
        {
          type: "error",
          title: "Error",
          description: this._vm.$resourceString[
            "checkout.ProjectName.ValidationError"
          ]
        },
        { root: true }
      );
      commit("updateLoader", false);
      return;
    }
  
    // Validate Address
    let isAddressAvailable = true;
    if (!state.isMultipleAddressCheckout) {
      if (!state.currentAddress) {
        isAddressAvailable = false;
      }
    } else {
      if (state.checkoutList.siteItems.length > 0) {
        state.multipleItemsAddress.siteItems.forEach((element, indx) => {
          if (!element) {
            isAddressAvailable = false;
          }
        });
      }
      if (state.checkoutList.trayItems.length > 0 && !state.multipleItemsAddress.trayItems[0]) {
        isAddressAvailable = false;
      }
    }
  
    if (!isAddressAvailable) {
      dispatch(
        "notifications/add",
        {
          type: "error",
          title: "Error",
          description: this._vm.$resourceString[
            "checkout.Address.ValidationError"
          ]
        },
        { root: true }
      );
      commit("updateLoader", false);
      return;
    }
  
    // Validate Salesforce Opportunity fields
    if (state.opportunityId) {
      // If an existing opportunity is selected, skip further validation
    } else if (state.opportunityName && state.opportunityName !== "") {
      const isOpportunityValid = state.opportunityName && state.opportunityType && state.opportunityAccountId;
      if (!isOpportunityValid) {
        dispatch(
          "notifications/add",
          {
            type: "error",
            title: "Error",
            description: this._vm.$resourceString[
              "checkout.Opportunities.ValidationError"
            ]
          },
          { root: true }
        );
        commit("updateLoader", false);
        return;
      }
    }

    let checkoutItem = [];
    if (state.isMultipleAddressCheckout) {
      state.checkoutList.siteItems.forEach((element, index) => {
        let address = state.addresses.find(({ id }) => id === state.multipleItemsAddress.siteItems[index]);
        element.Address = address;
        element.ShippingOption = state.multipleItemShippingOption.siteItems[index];
        checkoutItem.push(element);
      });
      state.checkoutList.trayItems.forEach((element, index) => {
        let address = state.addresses.find(({ id }) => id === state.multipleItemsAddress.trayItems[0]);
        element.Address = address;
        element.ShippingOption = state.multipleItemShippingOption.trayItems[0];
        checkoutItem.push(element);
      });
    } else {
      checkoutItem = state.checkoutData.Items;
    }
    state.showAddressSuggestion = false;
  
    let address = "";
    if (state.currentAddress) {
      address = state.addresses.find(({ id }) => id === state.currentAddress);
    } else {
      address = state.addresses[0];
    }
    let dataCheckout = {
      ProjectName: state.checkoutData.ProjectName ? state.checkoutData.ProjectName : state.opportunityName,
      CreateStudio: {
        vehicleMake: state.vehicleMake,
        vehicleModel: state.vehicleModel,
        vehicleColor: state.vehicleColor,
        warehouse: state.showroomCodeName,
        deliveryMethod: state.deliveryMethod
      },
      SalesforceOpportunity: {
        Name: state.opportunityName,
        Type: state.opportunityType,
        AccountId: state.opportunityAccountId,
        DynamicProperties: state.opportunityDynamicProperties,
        OpportunityId: state.opportunityId
      },
      Company: state.checkoutData.Company,
      Occupation: state.checkoutData.Occupation,
      ProjectComments: state.checkoutData.ProjectComments,
      FirstName: address.firstName,
      LastName: address.lastName,
      Country: address.country,
      AddressLine1: address.streetLine1,
      Suite: address.suite,
      City: address.city,
      State: address.state,
      PostalCode: address.postalCode,
      Phone: address.cellPhone,
      Email: address.email,
      IsSplitOrder: state.isMultipleAddressCheckout,
      Items: checkoutItem,
      RedirectWithSelectedAddress: state.checkoutData.RedirectWithSelectedAddress,
      ShippingOption: state.checkoutData.ShippingOption
    };
    PatcraftApi.checkOutSubmit(dataCheckout)
      .then(res => {
        let data = res.data;
        commit("setCheckoutData", data);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  async validateUserAddressMellisa({ commit }, data) {
    commit("updateLoader", true);
    await PatcraftApi.validateUserAddress(data)
      .then(res => {
        commit("setMellisaValidationError", res.data);
      })
      .catch(error => {})
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  multipleAddressCheckout({ commit }, data) {
    commit("setMultipleAddressCheckout", data);
  },
  setInStock({ commit }, data) {
    commit("setInStock", data);
  },
  setMultipleItemAddress({ commit }, data) {
    commit("setMultipleItemAddress", data);
  },
  setMultipleItemShippingOption({ commit }, data) {
    commit("setMultipleItemShippingOption", data);
  },
  updateCurrentAddress({ commit }) {
    commit("setCurrentSuggestedAddress", "");
  },
  setShippingOption({ commit }, data) {
    commit("setShippingOption", data);
  },
  async saveUserAddress({ commit, state, dispatch }, data) {
    commit("updateLoader", true);
    await PatcraftApi.saveUserAddress(data)
      .then(res => {})
      .catch(error => {})
      .finally(() => {
        commit("updateLoader", false);
      });
    dispatch("fetchAddresses");
  },
  async editUserAddress({ commit, state, dispatch }, data) {
    commit("updateLoader", true);
    await PatcraftApi.editUserAddress(data)
      .then(res => {
        let dataObj = {
          isMultiple: state.currentAddressOption.isMultiple,
          list: state.currentAddressOption.list,
          index: state.currentAddressOption.index,
          addressId: data.id
        };
        commit("setMultipleItemAddress", dataObj);
      })
      .catch(error => {})
      .finally(() => {
        commit("updateLoader", false);
      });
    dispatch("fetchAddresses");
  },
  async removeUserAddress({ commit, state, dispatch }, data) {
    commit("updateLoader", true);
    await PatcraftApi.removeUserAddress(data)
      .then(res => {
        commit("removeSelectedAddress", data);
      })
      .catch(error => {})
      .finally(() => {
        commit("updateLoader", false);
      });
    dispatch("fetchAddresses");
  },
  getCountryStates({ commit }, data) {
    PatcraftApi.countryStates(data)
      .then(res => {
        commit("setCountryState", res.data);
      })
      .catch(error => {})
      .finally(() => {});
  },
  updateCheckoutData({ commit }, data) {
    commit("setCheckoutData", data);
  },
  updateRedirectWithSelectedAddress({ commit }, data) {
    commit("setRedirectWithSelectedAddress", data);
  },
  openEditAddressModal({ commit }, data) {
    commit("updateEditaddress");
  },
  updateErrorValidationDefault({ commit }) {
    commit("setErrorValidationDefault");
  },
  setCurrentAddressOption({ commit }, data) {
    commit("updateCurrentAddressOption", data);
  },
  addressValidation({ commit }, data) {
    commit("setFirstNameValidation", data.firstName);
    commit("setLastNameValidation", data.lastName);
    commit("setStreetLine1Validation", data.streetLine1);
    commit("setCityValidation", data.city);
    commit("setStateValidation", data.state);
    commit("setCountryValidation", data.country);
    commit("setPostalCodeValidation", data.postalCode);
    commit("setCellPhoneValidation", data.cellPhone);
    commit("setEmailValidation", data.email);
    commit("setCompanyValidation", data.company);
  },
  // Showrooms & Create Studio
  getShowrooms({ commit, dispatch, state }, data) {
    PatcraftApi.getAllShowrooms(data)
      .then(res => {
        if (res.data) {
          commit("setShowrooms", res.data);
        }
      })
      .catch(error => {
        console.error("Error fetching showrooms:", error);
        throw error;
      });
  },
  getShowroomLocations({ commit, dispatch, state }, data) {
    PatcraftApi.getAllShowroomLocations(data)
      .then(res => {
        if (res.data) {
          commit("setShowroomLocations", res.data);
        }
      })
      .catch(error => {
        console.error("Error fetching showroom locations:", error);
        throw error;
      });
  },
  setShowroomCodeName({ commit }, data) {
    commit("setShowroomCodeName", data);
  },
  async getGimbleServiceData({ commit, dispatch, state }, data) {
    try {
      let response = await PatcraftApi.getGimbleInventory(data);
      commit("setGimbleData", response.data);
      return response;
    } catch (error) {
      console.error("Error while fetching Gimble service data:", error);
      throw error;
    }
  },
  setVehicleMake({ commit }, data) {
    commit("setVehicleMake", data);
  },
  setVehicleModel({ commit }, data) {
    commit("setVehicleModel", data);
  },
  setVehicleColor({ commit }, data) {
    commit("setVehicleColor", data);
  },
  setDeliveryMethod({ commit }, data) {
    commit("setDeliveryMethod", data);
  }
};

// Mutations
const mutations = {
  // Salesforce Opportunities
  setOpportunityData(state, data) {
    const opportunityData = data.SalesforceOpportunity || {};
    state.opportunityId = opportunityData.Id || state.opportunityId;
    state.opportunityName = opportunityData.Name || state.opportunityName;
    state.opportunityType = opportunityData.Type || state.opportunityType;
    state.opportunityAccountId = opportunityData.AccountId || state.opportunityAccountId;
    state.opportunityDynamicProperties = opportunityData.DynamicProperties || state.opportunityDynamicProperties;
  },
  setOpportunityName(state, data) {
    state.opportunityName = data;
  },
  setOpportunityId(state, data) {
    state.opportunityId = data;
  },
  setOpportunityType(state, data) {
    state.opportunityType = data;
  },
  setOpportunityAccountId(state, data) {
    state.opportunityAccountId = data;
  },
  setOpportunityProperties(state, data) {
    state.opportunityDynamicProperties = data;
  },
  setOpportunityOptions(state, options) {
    state.existingProjectOptions = options;
  },
  setOpportunityError(state, error) {
    state.opportunityError = error;
  },
  setShowOpportunityForm(state, value) {
    state.showOpportunityForm = value;
  },
  setContactData(state, data) {
    state.contactData = data;
  },
  setPicklistValues(state, data) {
    state.picklistValues = data;
  },
  // Checkout and Shipping
  setProjectName(state, projectName) {
    state.checkoutData.ProjectName = projectName;
    state.validationErrorPName = false;
  },
  setAddresses(state, addresses) {
    let isDefaultSelected = false;
    addresses.forEach(element => {
      if (element.isDefault === true) {
        isDefaultSelected = true;
      } else if (element.isDefault === false && !isDefaultSelected) {
        isDefaultSelected = false;
      }
      state.isDefaultSelected = isDefaultSelected;
    });
    state.addresses = addresses;
  },
  setGimbleData(state, data) {
    state.gimbleData = data;
  },
  setInStock(state, data) {
    state.inStock = data;
  },
  setMultipleAddressCheckout(state, data) {
    state.isMultipleAddressCheckout = data;
  },
  updateCurrentAddressOption(state, data) {
    state.currentAddressOption = data;
  },
  setMultipleItemAddress(state, data) {
    let getCookieData = this._vm.$cookies.get("OrderAddresses");
    if (data.isMultiple) {
      if (data.list === "SiteItems") {
        state.multipleItemsAddress.siteItems[data.index] = data.addressId;
        let indexSiteCookie = getCookieData.multipleAddress.site.findIndex(
          ({ cartId }) => cartId === state.checkoutList.siteItems[data.index].Item.CartItemId
        );
        getCookieData.multipleAddress.site[indexSiteCookie].addressGuid = data.addressId;
      } else {
        state.multipleItemsAddress.trayItems[data.index] = data.addressId;
        getCookieData.multipleAddress.tray.addressGuid = data.addressId;
      }
    } else {
      state.currentAddress = data.addressId;
      getCookieData.singleAddress.addressGuid = data.addressId;
    }
    this._vm.$cookies.set("OrderAddresses", getCookieData, "1m");
  },
  setMultipleItemShippingOption(state, data) {
    state.multipleItemShippingOption.siteItems[data.listIndex] = data.value;
    state.multipleItemShippingOption = Object.assign({}, state.multipleItemShippingOption);
    let getCookieData = this._vm.$cookies.get("OrderAddresses");

    let indexSiteCookie = getCookieData.multipleAddress.site.findIndex(
      ({ cartId }) => cartId === state.checkoutList.siteItems[data.listIndex].Item.CartItemId
    );
    getCookieData.multipleAddress.site[indexSiteCookie].shippingOption = data.value;
    this._vm.$cookies.set("OrderAddresses", getCookieData, "1m");
  },
  removeSelectedAddress(state, data) {
    if (state.currentAddress === data) {
      state.currentAddress = "";
    }

    state.multipleItemsAddress.siteItems.forEach((element, index) => {
      if (element === data) {
        state.multipleItemsAddress.siteItems[index] = "";
      }
    });

    if (state.multipleItemsAddress.trayItems[0] === data) {
      state.multipleItemsAddress.trayItems[0] = "";
    }

    let getCookieData = this._vm.$cookies.get("OrderAddresses");
    if (getCookieData.singleAddress.addressGuid === data) {
      getCookieData.singleAddress.addressGuid = null;
    }
    if (getCookieData.multipleAddress.tray.addressGuid === data) {
      getCookieData.multipleAddress.tray.addressGuid = null;
    }
    getCookieData.multipleAddress.site.forEach(element => {
      if (element.addressGuid === data) {
        element.addressGuid = null;
      }
    });
    this._vm.$cookies.set("OrderAddresses", getCookieData, "1m");
  },
  setCheckoutData(state, data) {
    state.checkoutData = data;
    if (state.checkoutData.SuccessfulSubmission === false) {
      state.showAddressSuggestion = data.ChangedAddress != null;
      if (state.checkoutData.Items) {
        state.checkoutList.trayItems = [];
        state.checkoutList.siteItems = [];
        let cookieData = this._vm.$cookies.get("OrderAddresses");
        if (!cookieData) {
          cookieData = {
            singleAddress: {
              addressGuid: null,
              shippingOption: "SecondDay"
            },
            multipleAddress: {
              site: [],
              tray: {
                addressGuid: null,
                shippingOption: "SecondDay"
              }
            },
            projectName: null
          };
        }
        if (cookieData.projectName) {
          state.checkoutData.ProjectName = cookieData.projectName;
        }

        state.currentAddress = cookieData.singleAddress.addressGuid;
        state.checkoutData.ShippingOption = cookieData.singleAddress.shippingOption;
        state.checkoutData.Items.forEach(element => {
          if (element.Item.IsTrayItem) {
            state.checkoutList.trayItems.push(element);
            state.multipleItemsAddress.trayItems[0] = cookieData.multipleAddress.tray.addressGuid;
          } else {
            state.checkoutList.siteItems.push(element);
            if (cookieData.multipleAddress.site.length > 0) {
              let isExist = cookieData.multipleAddress.site.findIndex(
                ({ cartId }) => cartId === element.Item.CartItemId
              );
              if (isExist < 0) {
                cookieData.multipleAddress.site.push({
                  cartId: element.Item.CartItemId,
                  addressGuid: null,
                  shippingOption: "SecondDay"
                });
                let arrayIndex = state.multipleItemsAddress.siteItems.length;
                state.multipleItemsAddress.siteItems[arrayIndex] = null;
                state.multipleItemShippingOption.siteItems[arrayIndex] = "SecondDay";
              } else {
                let existIndex = state.checkoutList.siteItems.findIndex(
                  ({ Item }) => Item.CartItemId === element.Item.CartItemId
                );
                state.multipleItemsAddress.siteItems[existIndex] = cookieData.multipleAddress.site[isExist].addressGuid;
                state.multipleItemShippingOption.siteItems[existIndex] = cookieData.multipleAddress.site[isExist].shippingOption || "SecondDay";
              }
            } else {
              cookieData.multipleAddress.site[0] = {
                cartId: element.Item.CartItemId,
                addressGuid: null,
                shippingOption: "SecondDay"
              };
              state.multipleItemsAddress.siteItems[0] = null;
              state.multipleItemShippingOption.siteItems[0] = "SecondDay";
            }
          }
        });
        this._vm.$cookies.set("OrderAddresses", cookieData, "1m");
      }
    }
  },
  setCountryState(state, data) {
    state.countryState = data;
  },
  setCurrentAddress(state, data) {
    state.currentAddress = data;
  },
  setRedirectWithSelectedAddress(state, data) {
    state.checkoutData.RedirectWithSelectedAddress = data;
  },
  setCurrentSuggestedAddress(state, data) {
    state.addresses[state.currentAddress].streetLine1 = state.checkoutData.ChangedAddress.AddressLine1;
    state.addresses[state.currentAddress].suite = state.checkoutData.ChangedAddress.AddressLine2;
    state.addresses[state.currentAddress].city = state.checkoutData.ChangedAddress.Locality;
    state.addresses[state.currentAddress].state = state.checkoutData.ChangedAddress.AdministrativeArea;
    state.addresses[state.currentAddress].postalCode = state.checkoutData.ChangedAddress.PostalCode;
    state.addresses[state.currentAddress].country = state.checkoutData.ChangedAddress.Country;
  },
  updateEditaddress(state, data) {
    state.editAddressModal = !state.editAddressModal;
  },
  updateLoader(state, data) {
    state.loader = data === true ? state.loader + 1 : state.loader - 1;
  },
  // Address Validation
  setErrorValidationDefault(state) {
    state.errors = {
      firstName: "",
      lastName: "",
      streetLine1: "",
      city: "",
      state: "",
      country: "",
      postalCode: "",
      cellPhone: "",
      email: "",
      company: ""
    };
  },
  setFirstNameValidation(state, data) {
    state.validationErrorFlag = false;
    state.errors.firstName = "";
    if (!data) {
      state.errors.firstName = "The First Name field is required";
      state.validationErrorFlag = true;
    }
  },
  setLastNameValidation(state, data) {
    state.errors.lastName = "";
    if (!data) {
      state.errors.lastName = "The Last Name field is required";
      state.validationErrorFlag = true;
    }
  },
  setStreetLine1Validation(state, data) {
    state.errors.streetLine1 = "";
    if (!data) {
      state.errors.streetLine1 = "The Street Line 1 field is required";
      state.validationErrorFlag = true;
    } else {
      if (data.length > 100) {
        state.errors.streetLine1 = "The maximum length allowed for the field has been exceeded";
        state.validationErrorFlag = true;
      }
    }
  },
  setCityValidation(state, data) {
    state.errors.city = "";
    if (!data) {
      state.errors.city = "The City field is required";
      state.validationErrorFlag = true;
    } else {
      if (data.length > 100) {
        state.errors.city = "The maximum length allowed for the field has been exceeded";
        state.validationErrorFlag = true;
      }
    }
  },
  setStateValidation(state, data) {
    state.errors.state = "";
    if (!data) {
      state.errors.state = "The State field is required";
      state.validationErrorFlag = true;
    }
  },
  setCountryValidation(state, data) {
    state.errors.country = "";
    if (!data) {
      state.errors.country = "The Country field is required";
      state.validationErrorFlag = true;
    }
  },
  setPostalCodeValidation(state, data) {
    state.errors.postalCode = "";
    if (!data) {
      state.errors.postalCode = "The Postal Code field is required";
      state.validationErrorFlag = true;
    } else {
      if (data.length > 20) {
        state.errors.postalCode = "The maximum length allowed for the field has been exceeded";
        state.validationErrorFlag = true;
      }
    }
  },
  setCellPhoneValidation(state, data) {
    state.errors.cellPhone = "";
    if (!data) {
      state.errors.cellPhone = "The Phone field is required";
      state.validationErrorFlag = true;
    } else {
      if (data.length < 10) {
        state.errors.cellPhone = "The Phone field is too short";
        state.validationErrorFlag = true;
      } else if (data.length > 20) {
        state.errors.cellPhone = "The maximum length allowed for the field has been exceeded";
        state.validationErrorFlag = true;
      }
    }
  },
  setEmailValidation(state, data) {
    state.errors.email = "";
    if (!data) {
      state.errors.email = "The Email field is required";
      state.validationErrorFlag = true;
    } else {
      if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/.test(data)) {
        state.errors.email = "The Email field is not valid";
        state.validationErrorFlag = true;
      }
    }
  },
  setCompanyValidation(state, data) {
    state.errors.company = "";
    if (!data) {
      state.errors.company = "The Company field is required";
      state.validationErrorFlag = true;
    }
  },
  setMellisaValidationError(state, data) {
    state.mellisaValidation = data;
  },
  // Showrooms & Create Studio
  setShowrooms(state, showrooms) {
    state.showrooms = showrooms;
  },
  setShowroomCodeName(state, data) {
    state.showroomCodeName = data;
  },
  setShowroomLocations(state, showroomLocations) {
    state.showroomLocations = showroomLocations;
  },
  setVehicleMake(state, data) {
    state.vehicleMake = data;
  },
  setVehicleModel(state, data) {
    state.vehicleModel = data;
  },
  setVehicleColor(state, data) {
    state.vehicleColor = data;
  },
  setDeliveryMethod(state, data) {
    state.deliveryMethod = data;
  },
  setShippingOption(state, data) {
    state.checkoutData.ShippingOption = data;
    let cookieData = this._vm.$cookies.get("OrderAddresses");
    if (cookieData) {
      cookieData.singleAddress.shippingOption = data;
    }
    this._vm.$cookies.set("OrderAddresses", cookieData, "1m");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
